import { RequestParams } from "@core/services/http/http.type";
import { Meta } from "./common.type";

export const RequestParamsDashboardType = {
  PURCHASED: 1,
  VIEWED: 2,
} as const;

export type RequestParamsDashboardType =
  (typeof RequestParamsDashboardType)[keyof typeof RequestParamsDashboardType];

export interface RequestParamsDashboard extends RequestParams {
  voucherCode?: string;
  startDate?: string;
  endDate?: string;
  userType?: string[];
  sortBy?: string;
  bookIds?: (number | string)[];
  bookId?: number;
  authorId?: number;
  type?: RequestParamsDashboardType;
}

export interface ResponseVoucherActiveInteraction<T> {
  data: {
    items: T[];
    meta: Meta;
    totalListener: number;
  };
  status: string;
}

export interface VoucherActiveInteraction {
  bookId: number;
  bookName: string;
  bookThumbnail: string;
  viewCount: number;
  listenCount: number;
  totalTime: number;
}

export interface GeneralInformation {
  totalBook: number;
  totalBookDuration: number;
  totalFollower: number;
  totalBookVipListen: number;
  totalPurchaseBook: number;
  totalBookFreeListen: number;
}

export interface BookPurchase {
  totalList: number;
  items: {
    bookId: number;
    bookName: string;
    thumbnailBook: string[];
    priceBook: number;
    listenCount: number;
    purchaseCount: number;
    totalTimeListen: string;
    viewCount: number;
    likeCount: number;
    shareCount: number;
    commentCount: number;
  }[];
  meta: Meta;
}

export interface BookInteraction {
  items: {
    totalView: number;
    totalLike: number;
    totalComment: number;
    totalShare: number;
    totalListen: number;
    label: string;
  }[];
}

export interface BookRevenue {
  totalMoneyAuthor: number | null;
  totalMoneyAllTime?: number | null;
  items: {
    bookId: number;
    thumbnails: string[];
    bookName: string;
    retailRevenue?: number | null;
    vipRevenue?: number | null;
    money: number;
    authorName: string;
    listens: number | null;
    listensAllTime?: number | null;
    purchases: number | null;
    moneyAllTime?: number | null;
  }[];
  meta: Meta;
}
